/**
 * AI-assisted RFP parser — hand-written wrapper for POST /rfp-parser/extract.
 * Operator pastes client's scope-of-work; backend returns a structured
 * extraction the Workloading screen can pre-fill from.
 */
import axiosInstance from './axios';

export type SuggestedServiceCode =
  | 'NIGHTLY_OFFICE_CLEAN'
  | 'GENERAL_OFFICE_CLEAN'
  | 'MEDICAL_OFFICE_CLEAN'
  | 'DAY_PORTER'
  | 'RESTAURANT_CLEAN'
  | 'WAREHOUSE_CLEAN'
  | 'GOVERNMENT_CLEAN'
  | 'EDUCATION_CLEAN'
  | 'POST_CONSTRUCTION_CLEAN'
  | 'FLOOR_CARE_STRIP_WAX';

export type RfpFrequency =
  | 'WEEKLY'
  | 'BIWEEKLY'
  | 'MONTHLY'
  | 'DAY_PORTER'
  | 'UNCLEAR';

export type RfpWeekday =
  | 'SUNDAY'
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY';

export interface RfpExtraction {
  clientPriceExpectation?: number;
  confidence: number;
  contractDurationMonths?: number;
  crewSize?: number;
  frequency?: RfpFrequency;
  hoursPerVisit?: number;
  notes?: string;
  operatingWeeksPerYear?: number;
  painPoints?: string[];
  requirements?: string[];
  scopeItems?: string[];
  siteDensity?: 'SPARSE' | 'STANDARD' | 'DENSE' | 'INDUSTRIAL';
  siteType?: string;
  soilLevel?: 'LIGHT' | 'STANDARD' | 'HEAVY';
  startDate?: string;
  suggestedServiceCode?: SuggestedServiceCode;
  totalCleanableSqft?: number;
  visitDays?: RfpWeekday[];
}

export interface RfpExtractResponse {
  extraction: RfpExtraction;
  usage: {
    cacheReadTokens: number;
    inputTokens: number;
    outputTokens: number;
  };
}

const extract = async (payload: {
  clientNameHint?: string;
  rfpText: string;
}): Promise<RfpExtractResponse> => {
  const { data } = await axiosInstance.post<RfpExtractResponse>(
    '/rfp-parser/extract',
    payload
  );
  return data;
};

const rfpParserApi = { extract };

export default rfpParserApi;
